/**
 * Sleeve Stars — Placeholder image patcher.
 * Slimmed to only the paint paths still in use by templates/index.json:
 *   - big_editorial (Dawn image-banner section)
 *   - materials (custom ss-materials anatomy image)
 * The original script targeted 7 sections; the other 5 (hero, founder_banner,
 * tagline_close, shop_by_support, ambassador) were removed/renamed in the
 * current homepage layout and the paint paths were dead runtime work.
 */
(function () {
  var IMAGES = {
    big_editorial: 'https://tempfile.aiquickdraw.com/gpt-image-2-apimart/1778486182364-hnhkepa04di.png',
    anatomy:       'https://tempfile.aiquickdraw.com/images/chatgpt/file_00000000d02071fd9d6a58629196039c.png'
  };

  // Translucent text-box tint for the big_editorial Dawn banner.
  var BIG_EDITORIAL_TINT = 'rgba(14,18,24,0.62)'; // Ink scrim

  function findSection(key) {
    return document.querySelector('.shopify-section[id$="__' + key + '"]');
  }

  function forceBg(el, url) {
    el.style.setProperty('background-image',    'url("' + url + '")', 'important');
    el.style.setProperty('background-size',     'cover',              'important');
    el.style.setProperty('background-position', 'center',             'important');
    el.style.setProperty('background-repeat',   'no-repeat',          'important');
    el.style.setProperty('background-color',    'transparent',        'important');
  }

  function killPlaceholderPseudo(section, key, selectors) {
    var hook = 'ss-killph-' + key;
    section.classList.add(hook);
    var styleId = 'ssph-' + key;
    if (document.getElementById(styleId)) return;
    var rules = selectors
      .map(function (sel) { return '.' + hook + ' ' + sel + '::after, .' + hook + ' ' + sel + '::before { content: none !important; display: none !important; }'; })
      .join('\n');
    var st = document.createElement('style');
    st.id = styleId;
    st.textContent = rules;
    document.head.appendChild(st);
  }

  function paintBigEditorial() {
    var section = findSection('big_editorial');
    if (!section) return false;
    var banner = section.querySelector('.banner');
    var media  = section.querySelector('.banner__media, .image-with-text__media, .banner__box-media');
    if (!media) return false;
    if (media.dataset.ssPainted === '1') return true;
    media.dataset.ssPainted = '1';

    if (banner) banner.style.setProperty('position', 'relative', 'important');

    media.style.setProperty('position', 'absolute', 'important');
    media.style.setProperty('inset',    '0',        'important');
    media.style.setProperty('width',    '100%',     'important');
    media.style.setProperty('height',   '100%',     'important');
    media.style.setProperty('z-index',  '0',        'important');
    forceBg(media, IMAGES.big_editorial);

    var svg = media.querySelector('.placeholder-svg');
    if (svg) svg.style.display = 'none';

    var content = section.querySelector('.banner__content, .image-with-text__content');
    if (content) {
      content.style.setProperty('position', 'relative', 'important');
      content.style.setProperty('z-index',  '1',         'important');
    }

    var box = section.querySelector('.banner__box, .image-with-text__text-item');
    if (box) {
      box.style.setProperty('background-color', BIG_EDITORIAL_TINT, 'important');
      box.style.setProperty('background-image', 'none', 'important');
      box.style.setProperty('padding', '2.25rem 2.5rem', 'important');
      box.style.setProperty('border-radius', '14px', 'important');
      box.style.setProperty('backdrop-filter', 'blur(3px)', 'important');
      box.style.setProperty('-webkit-backdrop-filter', 'blur(3px)', 'important');
    }

    killPlaceholderPseudo(section, 'big_editorial', ['.banner__media', '.image-with-text__media']);
    return true;
  }

  function paintAnatomy() {
    var section = findSection('materials');
    if (!section) return false;
    var wrap = section.querySelector('.ss-mat__anatomy-wrap');
    if (!wrap) return false;
    if (wrap.dataset.ssPainted === '1') return true;
    if (wrap.querySelector('img.ss-mat__anatomy-img')) {
      wrap.dataset.ssPainted = 'native';
      return true;
    }
    wrap.dataset.ssPainted = '1';
    var ph = wrap.querySelector('.ss-mat__placeholder');
    if (ph) ph.remove();
    var img = document.createElement('img');
    img.src = IMAGES.anatomy;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = 'Anatomy';
    img.className = 'ss-mat__anatomy-img ss-injected-img';
    wrap.appendChild(img);
    var mat = section.querySelector('.ss-mat');
    if (mat) mat.classList.remove('ss-mat--no-image');
    return true;
  }

  function init() {
    paintBigEditorial();
    paintAnatomy();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
